module.exports = __webpack_public_path__ + "img/Logo-28.82866c02.svg";